"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderForClaimingToolVehicleDto = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_validator_1 = require("class-validator");
const order_for_claiming_tool_vehicle_assignation_status_enum_1 = require("./order-for-claiming-tool-vehicle-assignation-status.enum");
class OrderForClaimingToolVehicleDto {
    constructor(init) {
        if (init) {
            Object.assign(this, init);
        }
    }
}
exports.OrderForClaimingToolVehicleDto = OrderForClaimingToolVehicleDto;
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.VehicleType),
    __metadata("design:type", Number)
], OrderForClaimingToolVehicleDto.prototype, "vehicleType", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Date)
], OrderForClaimingToolVehicleDto.prototype, "assignedAt", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Date)
], OrderForClaimingToolVehicleDto.prototype, "createdAt", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsEnum)(order_for_claiming_tool_vehicle_assignation_status_enum_1.OrderForClaimingToolVehicleAssignationStatus),
    __metadata("design:type", Number)
], OrderForClaimingToolVehicleDto.prototype, "assignationStatus", void 0);
//# sourceMappingURL=order-for-claiming-tool-vehicle.dto.js.map